import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import Printd from 'printd'
import VueBarcode from 'vue-barcode'

export default {
  name: 'confirm-line-haul-connection',
  components: {
    Paginate,
    DatePicker,
    BasicSelect,
    VueElementLoading,
    'barcode': VueBarcode
  },
  data: function() {
    return {
      barcodeValue: '11419106696',
      tripTitle:'Start Trip',
      srId:'',
      srList:[],
      srItemObj:{ value: "",text: ""},
      vehicleNo:'',
      vehicleOpenKM:'',
      deliveryOptionList:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"}],
      deliveryOptionListPrint:[{ text: "RTO"},{ text: "DTO"},{ text: "RVP"},{ text: "Delivery"}],
      deliveryOptionItemObj:{ text: ""},
      deliveryOption:'',
      deliveryOptionItemObjPrint:{ text: ""},
      deliveryOptionPrint:'',
      clientOptionList:[],
      clientOptionItemObj:{ value: "",text: ""},
      clientOption:'',
      srHubName:'',
      srName:'',
      shipmentNo:'',
      startTripFlag:false,
      vehicleTypeFlag:false,
      vehicleType:'',
      srVehicleList:[],
      vehicleNoItemObj:{value:'', text: ''},
      startAllocationFlag:false,
      isAllocation:false,
      srShipmentList:[],
      pendingShipmentList:[],
      pendingShipmentListMdl:[],
      srArrayList:[],
      errVehicleNo:'',
      isRSVSr:0,
      errVehicleKm:'',
      closeTripModel:false,
      openKmImg:'',
      openKm:'',
      closeKmImg:'',
      closeKm:'',
      latitude:'',
      longitude:'',
      tripId: '',
      srVehicleNo:'',
      originCloseImg:'',
      errorCloseKM: '',
      tripState: '',
      vehicleVendorId: '',
      isVehicleReplaced: false,
      isVehicleReplacedCheck: 0,
      isLoadingASL:false,
      loader:'<div class="velmld-spinner"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="18px" viewBox="0 0 24 30" xml:space="preserve"><rect x="0" y="5.59869" width="4" height="19.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="10" y="9.59869" width="4" height="11.8026" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite"></animate></rect> <rect x="20" y="12.4013" width="4" height="6.19739" fill="#FF6700"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate> <animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite"></animate></rect></svg></div>',
      srLoader:'',
      isLoadingAlc:false,
      totalPendingShipment:0,
      pageCount: 0,
      pageNo: 1,
      pageNoMdl:1,
      pageCountMdl:0,
      isLoadingPSL:false,
      pendingShipModel:false,
      isLoadingPSLModel:false,
      totalPendingShipmentMdl:0,
      srIdFlt:'',
      srListFlt:[],
      srItemObjFlt:{ value: "",text: ""},
      srListFlt:[],

      fromListFlt:[{ value: null,text: "All"},{ value: "FromMob",text: "From Mobile"},{ value: "FromWeb",text: "From Web"}],
      fromItemObjFlt:{ value: null,text: "All"},
      fromIdFlt:null,
      fromList:[{ value: "UA",text: "From Mobile"},{ value: "Web",text: "From Web"}],
      fromItemObj:{ value: "UA",text: "From Mobile"},
      fromId:"UA",
      srShipmentPrintList:[],
      isLoadingPrint:false,
      createdBy:'',
      srNameShipPrint:'',
      srPhoneShipPrint:'',
      flagShowPreviousShipment:false,
      showShipmentModel:false,
      showShipmentList:[],

      dismissSecs: 20,
      dismissCountDown: 0,
      allocationErrorMsg: "",
      dismissCountDownSuccess:0,
      allocationSuccessMsg: "",
      fieldErr:false,

      rtoDtoSheetTitle:'RTO Sheet',
      rtoDtoDrsTitle:'RTO DRS',
      rtoDRSBatchId:'',
      rtoDRSClientName:'',
      rtoDRSVendorName:'',
      rtoDRSWHHandOverPersonName:'',

      rtoRunSTHubName:'',
      rtoRunSTDrsNo:'',

      printDType:'',
      rvpShipmentsModel:false,

      fromToDate:'',
      fltpickup:'Pending',
      sAll: false,
      sAllMoreShip: false,
      selectedPickups: [],
      selectedPickupsMore:[],
      pickupList:[],
      pickupData:[{value:'Pending',text:'All Pending'},{value:'PendingNewPickUp',text:'Pending New PickUp To Assign'},{value:'PendingReAssigned',text:'Pending Re-Assign  For PickUp'}],
      pickupItem:{value:'Pending',text:'All Pending'},
      isChecked:false,
      isLoadingRvpPickup:false,
      errorRvpAllocation:'',
      successRvpAllocation:'',
      isAllocationRvp:false,
      suggestRVPArrayList:[],
      morePendingRVPShipmentsModel:false,
      isActiveRvp:false,
      searchByShippingId: '',
      PsearchByShippingId: ''
    }
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
    jsUcfirst: function(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext)
    this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
    this.createdBy = userdetail[0].email;
    this.getHubName(this.userHubId)
    this.loadSRList(this.userHubId)
    this.vehicleNoRegExp = new RegExp('^[A-Z]{2}[ -][0-9]{1,2}(?: [A-Z])?(?: [A-Z]*)? [0-9]{4}$');

    if(this.userHubId==1091) {
      var fromListFlt = this.fromListFlt.filter(n => {
        if(n.value!=null) {
          return n
        }
      })
      this.fromListFlt = fromListFlt
      this.fromItemObjFlt = { value: 'FromWeb',text: "From Web"}
      this.fromIdFlt = 'FromWeb'
    }
  },
  computed: {
    flagAllocation() {
      if(this.deliveryOption=="Delivery") {
        var isComplete = this.deliveryOption && this.shipmentNo
      } else {
        var isComplete = this.deliveryOption && this.clientOption && this.shipmentNo
      }
      return isComplete
    },
    totalCODAmount() {
      var totalAmount = 0
      for (var i = 0; i < this.srShipmentPrintList.length; i++) {
        if(this.srShipmentPrintList[i].OrderType=="COD" || this.srShipmentPrintList[i].OrderType=="cod") {
          totalAmount += parseFloat(this.srShipmentPrintList[i].NetPayment)
        }
      }
      return totalAmount.toFixed(2);
    }
  },
  created() {
    // axios.interceptors.request.use((config) => {
    //   this.setLoading(true);
    //   return config;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
    //
    // axios.interceptors.response.use((response) => {
    //   this.setLoading(false);
    //   return response;
    // }, (error) => {
    //   this.setLoading(false);
    //   return Promise.reject(error);
    // });
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDownChangedSuccess(dismissCountDownSuccess) {
      this.dismissCountDownSuccess = dismissCountDownSuccess
    },
    getHubName(hubid) {
      this.input = {
        hubids: [hubid]
      }
      axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getHubServicecenterHubarray',
          data: this.input
        })
        .then(result => {
          if (result.data.code == 200) {
            this.hubName = result.data.data[0].HubName
            this.latitude = result.data.data[0].Latitude
            this.longitude = result.data.data[0].Longitude
          } else {
            this.hubName = '';
          }
          this.inputHub = {
            "Outsourceid":4,
            "hubid":this.userHubId
          }
          axios({
            method: 'POST',
            headers: {
              authorization : 'authkey xB84JJ89Hd25'
            },
            url: apiUrl.api_url_hubops + 'getHubFlags',
            data: this.inputHub
          })
          .then(result => {
            if (result.data.code==200) {
              this.isRSVSr = result.data.data.IsRSVSr
            } else {
              this.$alertify.error(result.data.message)
            }
          }, error => {
            console.error(error)
          })
        }, error => {
          console.error(error)
        })
    },
    loadSRList(hubid) {
      this.srLoader = this.loader
      this.srArrayList = []
      this.srList = []
      this.srListFlt = []
      if(hubid) {
        this.input = {
          "usertype":"3",
        	"hubid":[hubid],
        	"appkey":"$UNF#APP&MOB$"
        }
        axios({
          method: 'POST',
          url: apiUrl.api_url + 'users/HubDeliveryUsers/List',
          data: this.input
        })
        .then(result => {
          if (result.data.code == 200) {
            this.srArrayList = result.data.results;
            for (var i = 0; i < this.srArrayList.length; i++) {
              this.srList.push({
                value: this.srArrayList[i].userid,
                text: this.srArrayList[i].FirstName+" "+this.srArrayList[i].LastName+" ("+this.srArrayList[i].userid+")"
              })
              this.srListFlt.push({
                value: this.srArrayList[i].userid,
                text: this.srArrayList[i].FirstName+" "+this.srArrayList[i].LastName+" ("+this.srArrayList[i].userid+")"
              })
            }
          } else {
            this.$alertify.error(result.data.message?result.data.message:'No Record found')
          }
          this.srLoader = ''
        }, error => {
          this.srLoader = ''
          console.error(error)
        })
      } else {
        this.$alertify.error("Current Hub Id not found.")
      }
    },
    selectSR(obj) {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.fieldErr = false
      this.startTripFlag = false

      this.srItemObj = obj
      this.srId = obj.value
      this.srName = obj.text
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      if(selectedSrDtl[0].EmpType==null || selectedSrDtl[0].EmpType=="") {
        this.fieldErr = true
        this.$alertify.error("EmpType not found against this SR, EmpType is required.")
        return false;
      } else {
        this.vehicleType = ""
        this.srVehicleList = []
        this.vehicleNoItemObj = {value:'', text: ''}
        this.vehicleOpenKM = ''
        this.vehicleNo = ''
        this.vehicleVendorId = 0
        this.startAllocationFlag = false
        this.tripTitle = 'Start Trip'

        this.errorCloseKM = ''
        this.closeKm = ''

        this.tripState= ''
        this.srShipmentList = []
        this.input = {
          "XBkey":"XB123",
        	"HubId":this.userHubId,
        	"DeliveryUserId":this.srId
        }
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getTripDetailsByHubIdAndDeliveryUserId',
          data: this.input
        })
        .then(result => {
          if (result.data.TripState=="closed") {
            this.tripState='created'
            this.startTripFlag = true
            this.$alertify.error(result.data.message)
            this.loadSrShipmentDetails()
          } else if(result.data.TripState=="created" || result.data.TripState=="start") {
            this.tripState=result.data.TripState
            this.startTripFlag = true
            this.tripTitle = "Continue with existing trip"
            this.$alertify.error(result.data.message)
            this.loadSrShipmentDetails()
          } else if (result.data.TripState=="deliveryuserclosed" && result.data.code==200 ) {
            this.openKM = result.data.OpenKM
            this.openKmImg = result.data.OpenKMImageUrl
            this.closeKmImg = result.data.CloseKMImagUrl
            this.originCloseImg = result.data.CloseKMImagUrl
            this.tripId = result.data.TripId
            this.srVehicleNo = result.data.VehicleNo
            this.openKm = result.data.OpenKM
            this.closeTripModel = true
          } else {
            this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message')
          }

        }, error => {
          console.error(error)
        })
      }
    },
    startTrip() {
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      if(this.tripTitle=='Start Trip') {
        this.vehicleTypeFlag = true
      } else {
        this.startAllocation(false)
      }
    },
    loadVehicleDetails(type) {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.startAllocationFlag = false
      this.vehicleType = type
      this.srVehicleList = []
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleOpenKM = ''
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      if(type=="bike") {
        this.input = {
          "srid":this.srId,
          "hubid":this.userHubId
        }
        var url = apiUrl.api_url_hubops + "getSrMappingByHubIdAndSrId"
      } else {
        this.input = {
          "HubId":this.userHubId
        }
        var url = apiUrl.api_url_hubops + "getVehicleDetailsByHubId"
      }
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: url,
        data: this.input
      })
      .then(result => {
        if (result.data.ResultCode==100) {
          if(type=="vehicle") {
            var srVehicleList = result.data.Data
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VendorVehicleId,text:srVehicleList[i].VehicleNumber})
            }
          } else {
            var srVehicleList = result.data.data
            for (var i = 0; i < srVehicleList.length; i++) {
              this.srVehicleList.push({value:srVehicleList[i].VehicleNumber,text:srVehicleList[i].VehicleNumber})
            }
          }

        } else {
          if(type=="vehicle") {
            this.$alertify.error("No record found.")
          }
        }
      }, error => {
        console.error(error)
      })
    },
    selectVehicleNo(obj) {
      this.vehicleNoItemObj = obj
      this.vehicleNo = obj.text
      this.vehicleVendorId = obj.value
    },
    startAllocation(flag) {
      this.flagShowPreviousShipment = false
      this.startAllocationFlag = false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      var decimal=  /^\d+(\.\d{1,2})?$/;

      if(decimal.test(this.vehicleOpenKM)==false && this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
          this.errVehicleKm = "Enter Correct KM"
      } else if(this.vehicleNoRegExp.test(this.vehicleNo.toUpperCase())==false && flag && this.vehicleVendorId==0) {
          this.errVehicleNo = "Enter Correct Vehicle No"
      } else if(decimal.test(this.vehicleOpenKM)==false && flag) {
          this.errVehicleKm = "Enter Correct KM"
      } else {
        this.deliveryOptionItemObj = { text: ""}
        this.deliveryOption = ""
        this.clientOptionItemObj = {value: "",text: ""}
        this.clientOption = ""
        this.shipmentNo = ''

        this.srName = this.srItemObj.text
        this.srHubName = this.hubName
        this.startAllocationFlag = true
        this.input = {
          "XBkey":"XB123"
        }
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops  + 'tripDetailsClientDropdownList',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            var clientOptionList = result.data.data
            for (var i = 0; i < clientOptionList.length; i++) {
              this.clientOptionList.push({value:clientOptionList[i].ClientMasterID,text:clientOptionList[i].CompanyName})
            }
          }
        }, error => {
          console.error(error)
        })
      }
    },
    selectDeliveryOption(obj) {
      this.flagShowPreviousShipment = false
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.deliveryOptionItemObj = obj
      this.deliveryOption = obj.text

      if(this.deliveryOption=="RVP") {
        this.isAllocationRvp = false;
        this.rvpShipmentsModel = true;
        this.pickupItem = {value:'Pending',text:'All Pending'}
        this.fltpickup = 'Pending'
        this.fromToDate = ""
        this.pickupList = []
        this.showPendingPickups()
      }
    },
    selectClient(obj) {
      this.flagShowPreviousShipment = false
      this.clientOptionItemObj = obj
      this.clientOption = obj.value
    },
    selectFrom(obj) {
      this.fromItemObj = obj
      this.fromId = obj.value
    },
    allocation() {
      this.allocationErrorMsg = ""
      this.allocationSuccessMsg = ""
      this.isLoadingAlc = true
      this.flagShowPreviousShipment = false
      var tempStr = this.shipmentNo
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srId
      })
      this.input = {
        "XBkey":"XB123",
      	"HubId":this.userHubId.toString(),
      	"DeliveryUserId":this.srId,
      	"OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
      	"DeliveryUserName":this.srName,
      	"ShippingID":this.shipmentNo,
      	"LastModifiedBy":this.createdBy,
      	"IsConfirmAllocation":false,
      	"AllocationType":this.deliveryOption,
        "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
      	"MarkedFrom":"Web",//this.fromId,
      	"CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
      	"IsRSVCSr":this.isRSVSr,
      	"MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
      }
      if(this.deliveryOption!="Delivery") {
        this.input["ClientId"] = this.clientOption
      }
      this.shipmentNo = ''
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'tripDetailsShipmentAllocate',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.isAllocation = true
          this.shipmentNo = ''
          this.loadSrShipmentDetails()
          this.$refs.shipmentNo.focus()
          this.dismissCountDownSuccess = this.dismissSecs
          this.allocationSuccessMsg = tempStr+" :- "+result.data.message
        } else {
          if(typeof result.data.status !=undefined && result.data.status==204) {
            this.flagShowPreviousShipment = true
          }
          this.$refs.shipmentNo.focus();
          //this.shipmentNo = tempStr;
          this.shipmentNo = '';
          this.dismissCountDown = this.dismissSecs
          this.allocationErrorMsg = result.data.message!='' && result.data.message!=undefined?`${tempStr} :-  ${result.data.message}`: `${tempStr} :- Not getting any response message.`
        }
        this.isLoadingAlc = false
      }, error => {
        this.shipmentNo = tempStr
        this.isLoadingAlc = false
        console.error(error)
      })
    },
    confirmTrip() {
      if(this.deliveryOption == '') {
        this.$alertify.error('Please select delivery option type !');
        $('#deliveryOption').focus();
      } else {
        this.isAllocationRvp = false
        this.flagShowPreviousShipment = false
        this.srName = this.srItemObj.text
        this.srHubName = this.hubName
        this.startAllocationFlag = true
        this.input = {
          "XBkey":"XB123",
        	"sruserid":this.srId.toString(),
        	"hubid":this.userHubId,
        	"km":this.vehicleOpenKM?this.vehicleOpenKM:0,
        	"tripstate":this.tripState,//"created",
        	"vehicleno":this.vehicleNo.toUpperCase(),
        	"vehicletype":this.vehicleType,
        	"triptype":this.deliveryOption,
        	"srname":this.srName,
        	"isvehiclereplaced":this.isVehicleReplaced,
        	"LastModifiedBy":this.createdBy,
        	"MarkedFrom":this.fromId,
        	"operationType":"lastmile"
        }
        if((this.vehicleType=='bike' && this.srVehicleList.length==0) || this.isVehicleReplaced==true) {
          this.input['isvehicleupdated'] = true
        } else {
          this.input['isvehicleupdated'] = false
        }
        if(this.tripTitle!='Start Trip') {
          this.input['isHandoverDeliveryUser'] = 1
        }
        if(this.vehicleType=='vehicle') {
          this.input['vehiclevendorid'] = this.vehicleVendorId
        }
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'tripDetailsShipmentConfirm',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.isAllocation = false
            this.$alertify.success(result.data.message)
            this.rvpShipmentsModel = false;
            this.resetTrip()
          } else {
            this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')

          }
        }, error => {
          console.error(error)
        })
      }
    },
    loadSrShipmentDetails() {
      this.srShipmentList = []
      if(this.srId) {
        this.isLoadingASL = true
        this.input = {
          "HubId": this.userHubId.toString(),
          "DeliveryUserId": this.srId
        }
        if(this.deliveryOption!="") {
          this.input["ShipmentType"] = this.deliveryOption
        }
        if(this.searchByShippingId !="") {
          this.input["ShippingId"] = this.searchByShippingId
        }
        //console.log('this.input',this.input);
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getAllocateShipmentSrDetails',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.srShipmentList = result.data.data;
            if(this.srShipmentList.length >= 1) {
              this.isAllocation = true
            }
          } else {
            this.isAllocation = false
          }
          this.isLoadingASL = false
        }, error => {
          this.isLoadingASL = false
          console.error(error)
        })
      }
    },
    loadPendingShipmentList() {
      this.isLoadingPSL = true
      this.pendingShipmentList = []
      this.input = {
        "HubID": this.userHubId.toString(),
        "ShipmentType":"Forward",
        "PageNo":this.pageNo
      }
      if(this.PsearchByShippingId !="") {
        this.input["ShippingId"] = this.PsearchByShippingId
      }
      //console.log('this.input',this.input);
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'getPendingShipmentDetails',
        data: this.input 
      })
      .then(result => {
        if (result.data.code==200) {
          this.pendingShipmentList = result.data.data
          this.totalPendingShipment = result.data.Total
          if (this.totalPendingShipment < 20) {
            this.pageCount = 1
          } else {
            this.pageCount = Math.ceil(this.totalPendingShipment / 20);
          }
        }
        this.isLoadingPSL = false
      }, error => {
        this.isLoadingPSL = false
        console.error(error)
      })
    },
    getPaginationData(pageNum) {
      this.pageNo = pageNum;
      this.loadPendingShipmentList();
    },
    closeCloseTripModel() {
      this.closeTripModel = false
    },
    loadOpenImageError(imageSrc, type) {
      var srcLink = "static/img/defaultImg.png"
      // var splitLink = imageSrc.split("id=")
      // if(splitLink.length>0) {
      //   if(splitLink[1]) {
      //     var srcLink = "https://drive.google.com/uc?export=view&id="+splitLink[1]
      //   }
      // }
      this.openKmImg = srcLink
    },
    loadCloseImageError(imageSrc) {
      var srcLink = "static/img/defaultImg.png"
      this.originCloseImg = imageSrc
      this.closeKmImg = srcLink
    },
    verifyTrip() {
      if(this.closeKm>this.openKm) {
        this.input = {
          "XBkey":"XB123",
          "tripid":this.tripId,
          "sruserid":this.srId.toString(),
          "hubid":this.userHubId,
          "km":this.closeKm,
          "tripstate":"closed",
          "vehicleno":this.srVehicleNo,
          "isvehiclereplaced":false,
          "latitude":this.latitude,
          "logitude":this.longitude,
          "speedmeterurl":this.originCloseImg,
          "lastmodifiedby":this.createdBy,
          "operationType":"lastmile"
        }
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getTripCloseDetails',
          data: this.input
        })
        .then(result => {
          if (result.data.code==200) {
            this.$alertify.success(result.data.message)
            this.resetTrip()
            this.closeTripModel = false
          } else {
            this.$alertify.error(result.data.message)
          }
        }, error => {
          console.error(error)
        })
      } else {
        this.errorCloseKM = "Close KM should be greater then open KM"
      }
    },
    isVehicleReplaceCheck(event) {
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      if(event==1) {
        this.isVehicleReplaced=true
      } else {
        this.isVehicleReplacedCheck = 0
        this.isVehicleReplaced=false
      }
    },
    removeShipment(shippingId) {
      if(shippingId) {
        this.isLoadingASL = true
        this.input = {
          "XBkey": "XB123",
        	"ShippingID": shippingId,
        	"LastModifiedBy": this.createdBy,
        }
        axios({
            method: 'POST',
            headers: {
              authorization : 'authkey xB84JJ89Hd25'
            },
            url: apiUrl.api_url_hubops + 'removeShipmentDetails',
            data: this.input
          })
          .then(result => {
            if (result.data.code==200) {
              this.loadSrShipmentDetails()
              this.$alertify.success("Shipment Successfully Removed")
            } else {
              this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
            }
            this.isLoadingASL = false
          }, error => {
            this.isLoadingASL = false
            console.error(error)
          })
      } else {
        this.$alertify.error("Shipment ID not found")
      }
    },
    isSameDayDelivery(flag) {
      var response = "No"
      if(flag) {
        var response = "Yes"
      }
      return response;
    },
    fullScreenPendingShipmentList() {
      this.pendingShipModel = true
      this.loadPendingShipmentListModel()
    },
    closePendingShipModel() {
      this.pendingShipModel = false
    },
    getPaginationDataModel(pageNum) {
      this.pageNoMdl = pageNum;
      this.loadPendingShipmentListModel();
    },
    loadPendingShipmentListModel() {
      this.isLoadingPSLModel = true
      this.pendingShipmentListMdl = []
      this.input = {
        "HubID": this.userHubId.toString(),
        "ShipmentType":"Forward",
        "PageNo":this.pageNoMdl
      }
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'getPendingShipmentDetails',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.pendingShipmentListMdl = result.data.data
          this.totalPendingShipmentMdl = result.data.Total
          if (this.totalPendingShipmentMdl < 20) {
            this.pageCountMdl = 1
          } else {
            this.pageCountMdl = Math.ceil(this.totalPendingShipmentMdl / 20);
          }
        }
        this.isLoadingPSLModel = false
      }, error => {
        this.isLoadingPSLModel = false
        console.error(error)
      })
    },
    selectSRFlt(obj) {
      this.srItemObjFlt = obj
      this.srIdFlt = obj.value
    },
    selectFromFlt(obj) {
      this.fromItemObjFlt = obj
      this.fromIdFlt = obj.value
    },
    selectDeliveryOptionPrint(obj) {
      this.deliveryOptionItemObjPrint = obj
      this.deliveryOptionPrint = obj.text
    },
    printShipmentForDelivery(dType) {

      this.printDType = dType
      if(dType=="delivery" && (this.deliveryOptionPrint=='RTO' || this.deliveryOptionPrint=='DTO')) {
        this.printDType = "printRTORunsheet";
      } else if (dType=="delivery" && this.deliveryOptionPrint=='RVP') {
        this.printDType = "printRVP";
      }
      this.rtoDtoDrsTitle='RTO DRS';
      this.rtoDtoSheetTitle='RTO Sheet';
      if(this.deliveryOptionPrint=='DTO') {
        this.rtoDtoDrsTitle='DTO DRS';
        this.rtoDtoSheetTitle='DTO Sheet';
      }

      this.srShipmentPrintList = []
      var selectedSrDtl = this.srArrayList.filter(n=>{
        return n.userid==this.srIdFlt
      })
      this.srNameShipPrint = selectedSrDtl[0].FirstName+" "+selectedSrDtl[0].LastName+" ("+selectedSrDtl[0].userid+")"
      this.srPhoneShipPrint = selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
      this.isLoadingPrint = true
      this.input = {
        "DeliveryUserID" : this.srIdFlt,
        "PrintFrom": this.fromIdFlt
      }
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'webGetShipmentBySrId',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.srShipmentPrintList = result.data.data
          if(this.srShipmentPrintList.length>0) {
            this.rtoDRSBatchId=this.srShipmentPrintList[0].AssignBatchNo
            this.rtoDRSClientName=''
            this.rtoDRSVendorName=this.srShipmentPrintList[0].RTOName
            this.rtoDRSWHHandOverPersonName=''

            this.rtoRunSTHubName=this.srShipmentPrintList[0].HubName
            this.rtoRunSTDrsNo=this.srShipmentPrintList[0].AssigneBatchNo
          }
        } else {
          this.$alertify.error(result.data.message)
        }
        this.isLoadingPrint = false
      }, error => {
        console.error(error)
      })
    },
    printShipments() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:2px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .td-width{
             width:10px!important;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }


           .tbl-fs16 {
             font-size:16px;
             font-weight:bold
           }
           td span {
             font-size:14px !important;
           }

           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
           .pagebreak { page-break-before: always; }
          }
          `
      d.print(document.getElementById('printShipmentContent'), cssText);
    },
    printShipDateTime() {
      return moment().format('DD-MM-YYYY') +" @ "+ moment().format('HHmm')
    },
    currentDate() {
      return moment().format('DD-MM-YYYY');
    },
    currentTime() {
      return moment().format('HH:mm:ss');
    },
    closeShipmentModel() {
      this.showShipmentModel=false
    },
    ShowShipments() {
      this.showShipmentModel=false
      this.showShipmentList = []
      this.input = {
        "DeliveryUserId": this.srId
      }
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'getShipmentPrevious',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.showShipmentList = result.data.data
          this.showShipmentModel=true
        } else {
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
      }, error => {
        console.error(error)
      })
    },
    resetTrip() {
      this.isVehicleReplacedCheck = 0
      this.isVehicleReplaced=false
      this.errVehicleNo = ""
      this.errVehicleKm = ""
      this.tripTitle = 'Start Trip'
      this.isRSVSr = 0
      this.srId = ''
      this.srName = ''
      this.srItemObj = { value: "",text: ""}
      this.startTripFlag = false
      this.vehicleTypeFlag = false
      this.vehicleType = ""
      this.vehicleNoItemObj = {value:'', text: ''}
      this.vehicleNo = ''
      this.vehicleVendorId = 0
      this.vehicleOpenKM = ''
      this.startAllocationFlag = false

      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.shipmentNo = ''
      this.isAllocation = false
      this.fromItemObj = { value: "UA",text: "From Mobile"}
      this.fromId = "UA"

      this.tripId = ''
      this.openKm = ''
      this.openKmImg = ''
      this.closeKm = ''
      this.closeKmImg = ''
      this.originCloseImg = ''
      this.latitude = ''
      this.longitude = ''
      this.srVehicleNo = ''
      this.errorCloseKM = ''

      this.srShipmentList = []
      this.flagShowPreviousShipment = false

      this.fromToDate= ''
      this.fltpickup= 'Pending'
      this.selectedPickups= []
      this.selectedPickupsMore=[]
      // this.resetBulkAllocation()
    },
    selectAll() {
      if (this.sAll) {
        this.pickupList.forEach((data) => {
          this.selectedPickups.indexOf(data.ShippingId) == -1 ? this.selectedPickups.push(data.ShippingId) : ''
        })
      } else {
        this.selectedPickups = []
      }
    },
    selectAllMoreRVPShipments() {
      if (this.sAllMoreShip) {
        this.suggestRVPArrayList.forEach((data) => {
          this.selectedPickupsMore.indexOf(data.ShippingId) == -1 ? this.selectedPickupsMore.push(data.ShippingId) : ''
        })
      } else {
        this.selectedPickupsMore = []
      }
    },
    closeRvpShipmentsModel() {
      this.clientOptionItemObj = {value: "",text: ""}
      this.clientOption = ""
      this.deliveryOptionItemObj = { text: ""}
      this.deliveryOption = ""
      this.$validator.reset();
      this.rvpShipmentsModel = false;
    },
    showPendingPickups() {
      this.fromId="UA",
      this.fromItemObj = { value: "UA",text: "From Mobile"}
      this.isLoadingRvpPickup = true
      this.errorRvpAllocation = '';
      this.successRvpAllocation = '';
      this.pickupList = []
      this.selectedPickups = []
      this.selectedPickupsMore = []
      this.morePendingRVPShipmentsModel = false
      this.isActiveRvp=false
      this.sAll = ''
      this.fromDate = null;
      this.toDate = null;
      if(this.fromToDate) {
        this.fromDate = this.fromToDate[0]?moment(this.fromToDate[0]).format('YYYY-MM-DD'):null;
        this.toDate = this.fromToDate[1]?moment(this.fromToDate[1]).format('YYYY-MM-DD'):null;
      }
      this.input = {
        "hubid": this.userHubId,
        "shipmenttype": "Reverse",
        "status": this.fltpickup,
        "clientbusinessdetailid": null,
        "FromDate": this.fromDate,
        "ToDate": this.toDate
      }
      axios({
        method: 'POST',
        headers: {
          authorization : 'authkey xB84JJ89Hd25'
        },
        url: apiUrl.api_url_hubops + 'getShipmentReversePendingList',
        data: this.input
      })
      .then(result => {
        if (result.data.code==200) {
          this.pickupList = result.data.data
        } else {
          this.$alertify.error(result.data.message!='' && result.data.message!=undefined?result.data.message:'Not getting any response message.')
        }
        this.isLoadingRvpPickup = false
      }, error => {
        this.isLoadingRvpPickup = false
        console.error(error)
      })
    },
    selectPickups(obj) {
      this.pickupItem = obj
      this.fltpickup = obj.value
    },
    checkPendingForRVP() {
      this.selectedPickupsMore=[]
      this.getPendingForRVPList().then( (result) => {
        if(result.success) {
          this.morePendingRVPShipmentsModel = true
          this.isActiveRvp=true
        } else {
          this.allocatePickup()
        }
      });
    },
    allocatePickup() {
      this.selectedPickups = this.selectedPickups.concat(this.selectedPickupsMore)
      var self = this;
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      if(this.selectedPickups.length>0) {
        this.isLoadingRvpPickup = true
        this.resArray = [];
        var successCount = 0;
        var failCount = 0;
        var failCountFutureDate = 0;
        var failShipmentsFDArray = [];
        var failShipmentsArray = [];

        let chain = Promise.resolve();
        for(let val of this.selectedPickups) {
          chain = chain.then(() => self.bulkAllocation(val));
        }
        chain.then(() => {
          var result = this.resArray
          for (var i = 0; i < result.length; i++) {
            if (result[i].statusCode==206) {
              failShipmentsFDArray.push(result[i].shippingId)
              failCountFutureDate++;
            } else if (result[i].statusCode==200) {
              successCount++;
            } else {
              failCount++;
            }
          }
          if(failCount>0) {
            self.errorRvpAllocation = failCount+" shipping ids cannot assign for pickup."
          }
          if(failCountFutureDate>0) {
            self.errorRvpAllocation = failCountFutureDate+" these shipping ids cannot assign for pickup, because pickup date set as a future date.";
          }
          if(successCount>0) {
            this.isAllocationRvp = true;
            this.morePendingRVPShipmentsModel = false
            this.isActiveRvp=false
            self.successRvpAllocation = successCount+" shipments allocated successfully";
          }
          this.isLoadingRvpPickup = false;
        }).catch(err=>{
          self.errorRvpAllocation = err.message;
          this.isLoadingRvpPickup = false;
        });
      }
    },
    bulkAllocation(shippingId) {
      if($("#CI"+shippingId).val()!=undefined && $("#CI"+shippingId).val()!="") {
        var clientId = $("#CI"+shippingId).val();
        return new Promise( (resolve, reject) => {
          this.files = []
          var selectedSrDtl = this.srArrayList.filter(n=>{
            return n.userid==this.srId
          })
          this.input = {
            "XBkey":"XB123",
          	"HubId":this.userHubId.toString(),
          	"DeliveryUserId":this.srId,
          	"OldDeliveryUserOrUserId":selectedSrDtl[0].OldDeliveryUserOrUserId?selectedSrDtl[0].OldDeliveryUserOrUserId.toString():"0",
          	"DeliveryUserName":this.srName,
          	"ShippingID":shippingId,
          	"LastModifiedBy":this.createdBy,
          	"IsConfirmAllocation":false,
          	"AllocationType":this.deliveryOption,
            "EmpType":selectedSrDtl[0].EmpType?selectedSrDtl[0].EmpType:"",
          	"MarkedFrom":"Web",//this.fromId,
          	"CourierCompanyID":selectedSrDtl[0].CourierCompanyID?selectedSrDtl[0].CourierCompanyID.toString():'null',
          	"IsRSVCSr":this.isRSVSr,
          	"MobileNo":selectedSrDtl[0].MobileNumber?selectedSrDtl[0].MobileNumber.toString():""
          }
          if(this.deliveryOption!="Delivery") {
            this.input["ClientId"] = clientId
          }
          axios({
            method: 'POST',
            headers: {
              authorization : 'authkey xB84JJ89Hd25'
            },
            url: apiUrl.api_url_hubops + 'tripDetailsShipmentAllocate',
            data: this.input
          })
          .then(result => {
            var result = result.data
            if(result.status==204) {
              reject({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId});
            } else if (result.status==206) {
              this.resArray.push({"success":false, "statusCode":result.status, "message":result.message, "shippingId":shippingId})
              resolve();
            } else if (result.code==200) {
              $("#rvpTr"+shippingId).remove();
              for (var i = 0; i < this.selectedPickups.length; i++) {
                if(this.selectedPickups[i]==shippingId) {
                  this.selectedPickups.splice(i, 1);
                }
              }
              this.resArray.push({"success":true, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
              resolve();
            } else {
              this.resArray.push({"success":false, "statusCode":result.code, "message":result.message, "shippingId":shippingId})
              resolve();
            }
          }, error => {
            console.error(error)
            reject({"success":false, "statusCode":null, "message":"server error, Try later"});
          })
        })
      } else {
        reject({"success":false, "statusCode":null, "message":"ClientId not found"});
      }
    },
    getPendingForRVPList() {
      this.errorRvpAllocation = "";
      this.successRvpAllocation = '';
      return new Promise( (resolve, reject) => {
        this.suggestRVPArrayList = []
        var relShippingIds = []
        axios({
          method: 'POST',
          headers: {
            authorization : 'authkey xB84JJ89Hd25'
          },
          url: apiUrl.api_url_hubops + 'getRvpShipment',
          data: {ShippingID:this.selectedPickups}
        })
        .then(response => {
          var resultData = response.data
          if(resultData.code == 200 && typeof resultData.data !== 'undefined') {
            var result = resultData.data
            for (var i = 0; i < result.length; i++) {
              if(result[i].ReversePickUpData.length>0) {
                let tempData = result[i].ReversePickUpData
                for (var j = 0; j < tempData.length; j++) {
                  relShippingIds.push(tempData[j])
                }
              }
            }
            if(relShippingIds.length>0) {
              for (var i = 0; i < relShippingIds.length; i++) {
                for (var j = 0; j < this.selectedPickups.length; j++) {
                  if(relShippingIds[i]==this.selectedPickups[j]) {
                    relShippingIds.splice(i,1);
                  }
                }
              }
              var uniqueArray = []
              for (var i = 0; i < relShippingIds.length; i++) {
                if(uniqueArray.indexOf(relShippingIds[i]) === -1) {
                  uniqueArray.push(relShippingIds[i]);
                }
              }
              // console.log(uniqueArray.length);
              // console.log(this.pickupList.length);
              var suggestRVPArrayList=[]
              for (var i = 0; i < this.pickupList.length; i++) {
                if(uniqueArray.includes(this.pickupList[i].ShippingId)) {
                  this.suggestRVPArrayList.push(this.pickupList[i]);
                }
              }
              resolve({success:true});
            }
          } else {
            resolve({success:false});
          }
        }, error => {
          resolve({success:false});
        })
      });
    },
    closeMPRVPShipments() {
      this.morePendingRVPShipmentsModel = false
      this.isActiveRvp=false
      this.errorRvpAllocation=''
      this.successRvpAllocation=''
    },
    resetBulkAllocation() {
      this.fromToDate= ''
      this.fltpickup= 'Pending'
      this.selectedPickups= []
      this.selectedPickupsMore = []
      this.pickupList= []
      this.pickupItem= {value:'Pending',text:'All Pending'}
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/Allocation/Allocation.js